import React, { Component } from 'react';
// import video_banner from "assets/img/video_banner.jpg";

import app_screen_1 from "assets/img/app_screens_1.png";
import app_screen_2 from "assets/img/app_screens_2.png";
import app_screen_3 from "assets/img/app_screens_3.png";
import app_screen_4 from "assets/img/app_screens_4.png";
import app_screen_5 from "assets/img/app_screens_5.png";
import video_banner_video from "assets/img/video_banner.png";

// import playBtn from "assets/img/playBtn.jpg";
import play_Btn from "assets/img/play-button.svg";


import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

class HowItWorks extends Component{
  constructor(props){
    super(props);
    this.state = {
      playVideo : true,
      buttonProp : true,
      controlsProp : false
    };
    
    this.playVid = this.playVid.bind(this);
    this.onPauseFunction = this.onPauseFunction.bind(this);
    this.onPlayFunction = this.onPlayFunction.bind(this);
  }
  onPlayFunction(){
    //console.log('1');
    // let vid = document.getElementById("playVid");

    // vid.play();
    this.setState({buttonProp:false}, function(){
      this.setState({controlsProp:true});
    });
    this.state.playVideo = !this.state.playVideo

  }
  onPauseFunction(){
    //console.log('2');
    // let vid = document.getElementById("playVid");
    // vid.pause();
    this.setState({buttonProp:true}, function(){
      //this.setState({controlsProp:false});
    });
    this.state.playVideo = !this.state.playVideo
  }
  playVid(){
    //console.log('3');
    let vid = document.getElementById("playVid");
    if(this.state.buttonProp){
      vid.play();
      this.setState({buttonProp:false}, function(){
        this.setState({controlsProp:true});
      });
      this.state.playVideo = !this.state.playVideo
    }
    else{
      vid.pause();
      this.setState({buttonProp:true}, function(){
        //this.setState({controlsProp:false});
      });
      this.state.playVideo = !this.state.playVideo
    }
  }
 	render(){
    const { buttonProp,controlsProp } = this.state;
  	return(
    	<div>
        <section className="section first_section not_home grey">
          <div className="section_title">
            <h2 className="mt-0">HOW IT WORKS</h2>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="video_container">
                  <video id="playVid" controls onPause={this.onPauseFunction} onPlay={this.onPlayFunction} width="740" height="478"  poster={video_banner_video}>
                    <source src="https://musicadjudicator.com/videos/music_adjudicator_demo.mp4" type="video/mp4" />
                  </video>
                  {
                    buttonProp && 
                    <img onClick={this.playVid} className="playBtn" height="83" src={play_Btn} />
                  }
                  
                  {
                    /*
                  <img src={video_banner} alt="videoBannerImage"/>
                  */
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section grey" id="help">
          <div className="screen_imgs">
          <OwlCarousel
            className="owl-theme"
            loop
            margin={50}
            nav={false}
            dots={false}
            responsiveClass={true}
            autoWidth={true} >

              
              <div className="img item"><img src={app_screen_1} alt="app_screen_1" /></div>
              <div className="img item"><img src={app_screen_2} alt="app_screen_2" /></div>
              <div className="img item"><img src={app_screen_3} alt="app_screen_3" /></div>
              <div className="img item"><img src={app_screen_4} alt="app_screen_4" /></div>
              <div className="img item"><img src={app_screen_5} alt="app_screen_5" /></div>
              
            </OwlCarousel>
          </div>
        </section>
     	</div>
  	);
  }
}
export default HowItWorks;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/HowItWorks.jsx